import axios from "axios";
// let admintoken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlYzJjOTYxNDk2NzdmNTVlMzY5NWJlMyIsImVtYWlsIjoidGVzdGFkbWluQGVtYWlsLmNvbSIsImNvbXBhbnlfaWQiOjIsImlhdCI6MTY0NDIzMDAzOH0.oawOmWLDxhEybJte7WlvRKJwsCVBDTdzwRyQ_rTFhvA'

const AuthStr = "Bearer " + localStorage.getItem("loginToken");
// const AuthStr = "Bearer " + admintoken;

function getApiCall(url) {
  return axios
    .get(process.env.REACT_APP_API_KEY + url, {
      headers: { Authorization: AuthStr },
    })
    .then((data) => {
      return data;
    });
}

function postApiCall(url, body) {
  return axios
    .post(process.env.REACT_APP_API_KEY + url, body, {
      headers: { Authorization: AuthStr },
    })
    .then((data) => {
      return data;
    });
}

function putApiCall(url, body) {
  return axios
    .put(process.env.REACT_APP_API_KEY + url, body, {
      headers: { Authorization: AuthStr },
    })
    .then((data) => {
      return data;
    });
}

function deleteApiCall(url, body) {
  return axios.delete(process.env.REACT_APP_API_KEY + url, {
    headers: { Authorization: AuthStr },
    data: body
  }).then((data) => {
    return data;
  });
}
function previewCall(url, body) {
  return axios
    .post(url, body, {
      dataType: "jsonp",
      contentType: "application/json",
      //headers: { Authorization: AuthStr },
    })
    .then((data) => {
      return data;
    });
}

export { getApiCall, postApiCall, previewCall, deleteApiCall, putApiCall };
